<template>
    <div>
        <v-row>
            <v-dialog
            v-model="userLoading"
            hide-overlay
            persistent
            width="300"
            >
            <v-card
                color="primary"
                dark
            >
                <v-card-text>
                Please stand by
                <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                ></v-progress-linear>
                </v-card-text>
            </v-card>
            </v-dialog>
        </v-row>
        <v-navigation-drawer v-if="!userLoading" class="gradient-bg" dark app clipped v-model="drawer">
            <v-list dense nav >
                <v-list-item link to="/dashboard">
                    <v-list-item-icon>
                        <v-icon>mdi-view-dashboard</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Dashboard </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="user.package != 'TRIAL'" link to="/positions">
                    <v-list-item-icon>
                        <v-icon>mdi-chart-line</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Open Positions</v-list-item-title>   
                </v-list-item>
                <v-list-item link to="/closedpositions">
                    <v-list-item-icon>
                        <v-icon>mdi-timer-lock</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Closed Positions</v-list-item-title>   
                </v-list-item>
                <v-list-item v-if="user.admin" link to="/researches">
                    <v-list-item-icon>
                        <v-icon>mdi-book-search</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Researches</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="user.admin" link to="/users">
                    <v-list-item-icon>
                        <v-icon>mdi-account-multiple</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Users</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="user.admin" link to="/columns">
                    <v-list-item-icon>
                        <v-icon>mdi-table-check</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Custom Columns</v-list-item-title>
                </v-list-item>

                <!-- <v-list-group
                    :value="false"
                    prepend-icon="mdi-book-open-variant-outline"
                >
                    <template v-slot:activator>
                            <v-list-item-title>Learn</v-list-item-title>
                    </template>
                    <v-list-item class="ml-4" link to="/training">
                        <v-list-item-content>
                            <v-list-item-title>Training</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="ml-4" link to="/traderule">
                        <v-list-item-content>
                            <v-list-item-title>Trade Rules</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="ml-4" link to="/insights">
                        <v-list-item-content>
                            <v-list-item-title>Insights</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>  -->
            </v-list>
            <template v-slot:append>
                <!-- <div class="pa-2">
                    <v-switch label="Dark mode" v-model="$vuetify.theme.dark"></v-switch>
                </div> -->
                <div class="pa-2">
                    <v-btn block @click="logout" color="orange" dark>Logout</v-btn>
                </div>
            </template>
        </v-navigation-drawer>
        <v-app-bar v-if="!userLoading" color="primary" dark app clipped-left>
            <v-app-bar-nav-icon
                @click="drawer = !drawer"
                aria-label="Toggle navigation menu"
            ></v-app-bar-nav-icon>
            <v-toolbar-title>Sigma Equity Research</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-avatar>
                <v-icon>
                    mdi-account-circle
                </v-icon>
            </v-avatar>
            {{ user.name }}
            <v-btn icon @click="dialog = true" aria-label="Open user profile menu">
                <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
        </v-app-bar>
        <v-main>
            <v-alert class="mt-5" :value="alert.alert" :type="alert.type">{{alert.message}}</v-alert>
            <router-view class="mt-5" />
            <v-row>
                <v-dialog v-model="dialog" max-width="700">
                    <v-card>
                        <v-card-title class="headline">User Profile</v-card-title>
                        <v-card-text>
                          <div>
                                <v-form>
                                    <v-text-field label="Name" filled prepend-inner-icon="mdi-account" :rules="req" v-model="name"></v-text-field>
                                    <v-text-field label="Phone" filled prepend-inner-icon="mdi-phone" :rules="phoneRules" v-model="phone"></v-text-field>
                                    <v-text-field disabled label="Email" filled prepend-inner-icon="mdi-email" readonly v-model="email"></v-text-field>
                                </v-form>
                            </div>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="green" @click="updateUser">Update</v-btn>
                            <v-btn @click="dialog1 = true" color="blue">Change Password</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="red" @click="dialog = false">Close</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
            <v-row>
                <v-dialog v-model="dialog1" max-width="500px">
                    <v-card>
                        <v-card-title>Reset Password</v-card-title>
                        <v-card-text>
                            <h4>A reset link will be sent to your email address "{{email}}"</h4>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="primary" @click="resetPassword">Reset</v-btn>
                            <v-btn color="red" @click="dialog1 = false">Close</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </v-main>
    </div>
</template>

<script>
import {supabase} from '../supabase'
export default {
    data: () => ({
        drawer: true,
        dialog: false,
        dialog1: false,
        name: '',
        phone: '', 
        email: '',
        req: [(v) => !!v || 'Required'],
        phoneRules: [
            (v) => !!v || 'Phone number is required',
            (v) => /^\d{10}$/.test(v) || 'Phone number must be 10 digits',
        ],
    }),
    methods: {
        updateUser () {
            if (this.name === '' || this.phone === '') {
                this.$store.dispatch('createAlert', {alert: true, type: 'error', message: 'Please fill all fields'})
                return
            }
            supabase
                .from('users')
                .update({ name: this.name, phone: this.phone })
                .select('*')
                .eq('id', this.user.id)
                .then(({ data, error }) => {
                    if (error) {
                        this.$store.dispatch('createAlert', {alert: true, type: 'error', message: error.message})
                    } else {
                        this.$store.dispatch('createAlert', {alert: true, type: 'success', message: 'User updated successfully'})
                        this.$store.commit('SET_USER', data[0])
                        console.log('User updated:', data[0]);
                        
                        this.setUser()
                        this.dialog = false
                    }
                })
                .catch((error) => {
                    this.$store.dispatch('createAlert', {alert: true, type: 'error', message: error.message})
                })
        },

        resetPassword() {
            supabase.auth.resetPasswordForEmail(this.email, {
                    redirectTo: 'https://positions.sigmaequityresearch.com/update-password',
                }).then(({data, error}) => {
                if(data) {
                    this.$store.dispatch('createAlert', {alert: true, type: 'success', message: 'Password reset email sent!'})
                    this.dialog1 = false
                }
                if(error) {
                    this.$store.dispatch('createAlert', {alert: true, type: 'error', message: error.message})
                }
            })
        },

        logout() {
            supabase.auth.signOut()
            this.$router.push('/')
        },
        setUser () {
            this.name = this.user.name
            this.phone = this.user.phone
            this.email = this.user.email
        },
    },
    computed: {
        alert () {
            return this.$store.getters.loadedAlert
        },
        user () {
            return this.$store.getters.loadedUser
        },
        userLoading () {
            return this.$store.getters.loadedUserLoading
        }
    },
    mounted () {
        this.setUser()
    },
};
</script>
